import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { Signature } from '@/types/signature';
import type { OrgOpSignableDecision } from '@mls-wallet/shared-types';

type CreatePolicySignatureArg = {
  proposalId: string;
  decision: OrgOpSignableDecision;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: CreatePolicySignatureArg }
): Promise<Signature[]> => {
  const { proposalId, decision } = arg;
  return await denApi.post<Signature[], { decision: OrgOpSignableDecision }>(
    `admin/policy/proposals/${encodeURIComponent(proposalId)}/signatures`,
    { decision }
  );
};

export function usePolicyProposalSignature(
  swrOptions?: SWRMutationConfiguration<
    Signature[],
    Error,
    string,
    CreatePolicySignatureArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    Signature[],
    Error,
    string,
    CreatePolicySignatureArg
  >('admin/policy/proposals/signature', fetcher, swrOptions);

  return { createSignature: trigger, isLoading: isMutating, error };
}
